module.exports = __webpack_public_path__ + "static/media/SpectrumMusic.e7a13a16.svg";